/**
 * Asset-status categories for the historical breakdown donut. Keys match the normalised
 * buckets returned by `groupStatusHistory`; colours mirror the legacy ESS "Activity History"
 * donut for feature parity.
 *
 * Kept in a standalone, dependency-free module so the ESS drawer, the machine drawer and their
 * specs can all share one source of truth: importing it from a component module would both drag
 * in that component's chart graph and be erased whenever a spec mocks the component.
 */
export const ESS_STATUS_CONFIG = {
    charging: {
        color: "#1AC69E",
        label: "Charging",
        tooltip: "Total time the asset spent charging (drawing energy to raise its State of Charge) over the selected range."
    },
    discharging: {
        color: "#FB5A00",
        label: "Discharging",
        tooltip: "Total time the asset spent discharging (delivering energy and lowering its State of Charge) over the selected range."
    },
    idle: {
        color: "#0066FF",
        label: "Idle",
        tooltip: "Total time the asset was connected but neither charging nor discharging over the selected range."
    },
    notreporting: {
        color: "#E1E1E1",
        label: "Not Reported",
        tooltip: "Total time the asset did not report any data over the selected range."
    }
};
